<template>
  <div>
    <div>

    <VerTurmas v-if="verTurmasModal" :turma_id="verTurmaId" v-on:close="closeVerTurmasModal()"/>
    <!--Begin Modal de preseça-->
    <new-vuestic-modal ref="presenca" v-bind:small="false" :cancelClass="'none'" okClass="none">
      <div slot="title">Registre sua presença</div>
      <div slot="body">
        <div class="container">
          <div class="row">
            <video class="col-6 webCam" autoplay="true" id="webCamera"></video>
            <img class="col-6 img-canvas" id="self" />
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="col-md-12">
          <div class="row">
            <button type="button" @click="self()" class="btn-primary btnmodal"><i class="fa fa-camera"></i>
              Capturar</button>
            <button v-if="loadBtnPresence" type="button" class="btn-primary btnmodal d-flex" disabled>
              <template v-if="loadBtnPresence">
                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#fff'" :size="30" width="200">
                </component>
              </template>
            </button>
            <button v-else type="button" class="btn-primary btnmodal d-flex" @click="registerFrequency()">
              <div>
                <i class="fa fa-id-card"></i> Registrar {{ btnPresenca }}
              </div>
            </button>
          </div>
        </div>
      </div>
    </new-vuestic-modal>

    <vuestic-modal ref="aguardando" v-bind:small="false" :cancelClass="'none'" okClass="none">
        <template>
            <div slot="title">Registre sua presença</div>
            <hr>
            <div class="container">
            <div class="row">
                <h1>Por gentileza, aguarde um momento. Dentro de instantes você será direcionado(a) para seu ambiente de aula!
                </h1>
            </div>
            </div>

            <div class="modal-footer">
            <slot name="footer">
                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
            </slot>
            </div>
        </template>
    </vuestic-modal>
    <!--End Modal de presença-->

      <!-- BEGIN Tela de carregamento -->
      <vuestic-widget class="ead-aluno-loading" v-if="loadingData || loadingButtons">
        <div class="col-md-12 mt-12 mb-3 d-flex justify-content-center">
          <strong class="font-weight-bold">Carregando os dados do aluno...</strong>
        </div>
        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
          <div class="btn-toolbar form-group" role="toolbar" aria-label="Toolbar with button groups">
            <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
          </div>
        </div>
      </vuestic-widget>
      <!-- END Tela de carregamento -->

      <div v-else class="ead-aluno-container">
        <section class="ead-aluno-aulas">
          <div class="ead-aluno-aulas-full" v-if="turmas.length > 0">
            <div class="aulas-header">
              <img src="~/assets/clock.svg" alt="">
              <strong>Sua próxima aula</strong>
            </div>

            <turmaCard :turma="currentTurma" :agora="agora" :isButtonDisabled="!classAvailability" :loading="loading"
              :classIsFinished="classIsUnavailable" @watch-class-click="validateFrequency(currentTurma)" />
            <div class="class-collapse-container">
              <alunoCollapse>
                <span slot="header">
                  <strong style="font-family: Arial, Helvetica, sans-serif; color: gray;">
                    <span class="sidebar-menu-item-icon fa fa-calendar mr-2" style="color: gray;"></span>
                    Próximas aulas agendadas
                  </strong>
                </span>
                <div slot="body">
                  <div class="row">
                    <div v-for="(materia, index) in turmas" :key="index" class="card col-md-12 mb-2">
                      <template v-if="index > 0">
                        <div class="card-body d-flex justify-content-between align-items-center">
                          <h4 class="card-title fa fa-book" style="color: gray; margin-bottom: 0px; font-size: 22px;">
                            <strong style="font-size: 18px; font-family: Arial, Helvetica, sans-serif;"> {{
                              materia.materia }}</strong>
                          </h4>
                          <div
                            style="font-size: 14px; color: white; background-color: gray; border-radius: 50px; padding: 5px 10px; margin-left: auto;">
                            <template>
                              {{ isClassToday(turmas[index].data_inicio) ? "Hoje, " :
                                isAulaAmanha(turmas[index].data_inicio) ? "Amanhã, " : formatDate(turmas[index].data_inicio)
                                  + ", " }}
                              {{ new Date(turmas[index].data_inicio).getHours() }}:{{ new
                                Date(turmas[index].data_inicio).getMinutes() < 10 ? "0" + new
                                  Date(turmas[index].data_inicio).getMinutes() : new
                                    Date(turmas[index].data_inicio).getMinutes() }} - {{ new
        Date(turmas[index].data_fim).getHours() }}:{{ new
    Date(turmas[index].data_fim).getMinutes() < 10 ? "0" + new
      Date(turmas[index].data_fim).getMinutes() : new Date(turmas[index].data_fim).getMinutes()
  }} </template>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </alunoCollapse>
            </div>
          </div>

          <AulasEmpty v-else title="Nenhuma aula encontrada."
            description="Parece que você ainda não tem nenhuma aula agendada." />
        </section>

        <section class="ead-aluno-aula-atual">
          <div class="col-12" v-if="turmas.length > 0">
            <div class="ead-aluno-aula-banner" v-if="classAvailability">
              <Banner title="Você já pode assistir sua aula."
                description="Procure um espaço calmo para que você possa se concentrar." image-name="podeAssistir.png" />

              <div class="actions-buttons">
                <button v-if="loading" class="botao-acessar-aula able-button" disabled>
                  <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="24"></component>
                </button>

                <button v-else class="botao-acessar-aula disabled-button" @click="validateFrequency(currentTurma)">
                  Entrar na aula
                  <i class="fa fa-arrow-right fa-lg"></i>
                </button>
                <button class="turma-button" @click="getAlunos">
                    Ver turma
                    <i class="fa fa-users"></i>
                </button>
              </div>
            </div>

            <div class="ead-aluno-aula-banner" v-else>
              <Banner v-if="classIsUnavailable" title="Essa aula não está mais disponível."
                description="Não é mais possível acessar essa aula." image-name="semAgendamento.png" />

              <Banner v-else title="Sua aula vai estar disponível em breve."
                description="Você poderá entrar na aula 30 minutos antes do início." image-name="awaiting.png" />

              <div class="actions-buttons">
                <button class="botao-acessar-aula disabled-button" disabled>
                  <template v-if="classIsUnavailable">
                    A aula não está mais disponível.
                  </template>

                  <template v-else>
                    Disponível às {{ aulaHorario }}
                  </template>
                  <i class="fa fa-lock fa-lg"></i>
                </button>
                <button class="turma-button" @click="getAlunos">
                  Ver turma
                  <i class="fa fa-users"></i>
                </button>
              </div>
            </div>
          </div>

          <div v-else>
            <Banner title="Você não tem nenhuma aula agendada." description="Tente entrar em contato com sua autoescola."
              image-name="semAgendamento.png" />
          </div>
        </section>

        <div class="row" v-if="turmas.length > 0">
          <ModalPresence v-if="cameraPermissionModal" title="Para entrar na aula, é necessário registrar sua presença."
            description="Habilite as permissões do navegador para registrar a presença." button-text="Permitir câmera"
            @close-modal="closePresenceModal" @handle-event="requestCameraPermission" :loading="loading"
            image-name="permitirCamera.png" />

          <ModalPresence v-if="showTakePhotoModal" title="Para entrar na aula, é necessário registrar sua presença."
            description="Verifique que sua foto estará visível." button-text="Tirar foto"
            @close-modal="closePresenceModal" @handle-event="takePhoto" :loading="loading" isPhoto>
            <video ref="camera" autoplay></video>
          </ModalPresence>

          <ModalPresence v-if="showPreviewModal" title="Foto Capturada" button-text="Salvar"
            @close-modal="closePresenceModal" @handle-event="registerFrequency" :loading="loading"
            :capturedImage="capturedImage" />

          <ModalPresence v-if="showErrorModal" title="Não foi possível detectar uma câmera em seu dispositivo."
            description="Permita o uso da câmera ou conecte uma câmera e tente novamente." button-text="Tentar novamente"
            @close-modal="closePresenceModal" @handle-event="tentarNovamente" :loading="loading"
            image-name="tentarNovamente.png" />
        </div>
      </div>
      <!--End Tabelas de Aulas-->
    </div>
  </div>
</template>

<script>
import modalCamera from './modal/modalCamera.vue'
import VerTurmas from './modal/verTurmas.vue'
import turmaCard from './componentes/turmaCard.vue'
import alunoCollapse from './componentes/alunoCollapse.vue'
import urlApi from '../../router/urlApi'
import * as spinners from 'epic-spinners'
import utils from '../../services/utils'
import router from '../../router'
import hourCurrentController from './hourCurrentController'
import Banner from './componentes/banner.vue'
import AulasEmpty from './componentes/aulas-empty.vue'
import ModalPresence from './componentes/modalPresence.vue'

export default {
  name: 'aulasTeoricas',
  components: {
    modalCamera,
    turmaCard,
    alunoCollapse,
    ...spinners,
    Banner,
    AulasEmpty,
    ModalPresence,
    VerTurmas
  },
  data () {
    return {
      turma: [],
      turmas: [],
      turmasReposicao: [],
      agrupamento: [],
      autoescolaTeste: ['teste2'],

      currentTurma: null,

      loadBtnPresence: false,
      loadBtnParticipate: false,
      nome: window.localStorage['nome'] ? window.localStorage['nome'].toUpperCase() : '',
      autoescola: window.localStorage['nome_fantasia'] !== 'null' ? window.localStorage['nome_fantasia'].toUpperCase() : '',

      aula: '',
      btnPresenca: '',
      photo: '',
      utils: utils,
      statusPresenca: 'SEM PRESENÇA',
      pagamento: null,
      tipoProcesso: null,
      setFrequency: false,
      agora: new Date(),
      showCameraModal: false,
      loadingData: true,
      classAvailability: false,
      loadingButtons: true,
      loading: false,
      classIsUnavailable: false,
      cameraPermissionModal: false,
      cameraPermissionGranted: false,
      showTakePhotoModal: false,
      capturedImage: null,
      mediaStream: null,
      showPreviewModal: false,
      showErrorModal: false,
      errorMessage: '',
      verTurmasModal: false,
      verTurmaId: null,
      id_role: null,
    }
  },
  methods: {
    closePresenceModal () {
      this.cameraPermissionModal = false
      this.showTakePhotoModal = false
      this.showPreviewModal = false
      this.showErrorModal = false
    },
    openCameraModal (turma) {
      this.cameraPermissionModal = true
      this.turma = turma
    },
    closeVerTurmasModal () {
      this.verTurmasModal = false
    },
    isAulaAmanha (dataAula) {
      const dataAtual = new Date()
      const dataAmanha = new Date(dataAtual)
      dataAmanha.setDate(dataAtual.getDate() + 1)

      return (
        dataAula.getDate() === dataAmanha.getDate() &&
        dataAula.getMonth() === dataAmanha.getMonth() &&
        dataAula.getFullYear() === dataAmanha.getFullYear()
      )
    },
    isClassToday (data) {
      const today = new Date()

      return (
        data.getDate() === today.getDate() &&
        data.getMonth() === today.getMonth() &&
        data.getFullYear() === today.getFullYear()
      )
    },
    formatDate (data) {
      const dia = data.getDate()
      const mes = data.getMonth() + 1
      const ano = data.getFullYear()

      return `${dia}/${mes}/${ano}`
    },
    join (agrupamento) {
      let instrutor = this.id_role === '3'
      let data = {
        sala: agrupamento.agrupamento, instrutor: instrutor, nome: localStorage.nome, id_aluno: localStorage.id, turma_teorica: agrupamento.id_turma_teorica
      }
      this.$http.post(urlApi + '/ead/meet', data)
        .then(response => {
          window.sessionStorage['agrupamento'] = JSON.stringify(agrupamento)
          window.sessionStorage['intervalo'] = false
          window.sessionStorage['saida'] = false
          router.push({ path: '/ead/' + btoa(btoa(response.body.link)) })
          this.loadBtnParticipate = false
          this.loadBtnPresence = false
        })
        .catch(() => {
          this.loadBtnParticipate = false
          this.loadBtnPresence = false
        })
    },
    async validateFrequency (agrupamento) {
      this.loading = true
      if (this.autoescolaTeste.includes(localStorage.getItem('schema')) && this.setFrequency) {
        this.$refs.aguardando.open('')
        return
      }
      this.loadBtnParticipate = true
      let validate = await this.validateMeeting(agrupamento)
      if (validate.sucesso) {
        if (validate.registro === '') {
          // presença ok entrar na sala
          this.join(agrupamento)
        } else {
          this.btnPresenca = validate.registro
          this.photo = ''
          document.querySelector('#self').setAttribute('src', '')
          this.agrupamento = agrupamento
          this.openCameraModal(agrupamento)
          // this.$refs.presenca.open('')
        }
      } else {
        this.loadBtnParticipate = false
      }
      this.loading = false
    },
    async validateMeeting (agrupamento) {
      // valida tolerancia inicial
      if (await this.validateBeginTime(agrupamento.data_inicio, agrupamento.data_fim) === false) {
        this.$toasted.show('Aula ainda não está disponível', {
          position: 'top-right',
        })
        return { sucesso: false, registro: null }
      } else {
        // valida entrada
        const [presence, intervalo] = await Promise.all([
            this.getPresence(agrupamento),
            this.setIntervalo(agrupamento)
        ]);
        if (presence) {
          // verificar intervalo
          const lastPresence = await this.consultLastPresence(agrupamento.id_turma_teorica)
          if (intervalo) {
            // registrar intervalo
            return lastPresence == 'INTERVALO' ? { sucesso: true, registro: '' } : { sucesso: true, registro: 'INTERVALO' }
          } else {
            // verificar se é pra registrar a saída
            if (await this.setExit(agrupamento.data_fim)) {
              // registrar saída
              return lastPresence == 'SAIDA' ? { sucesso: true, registro: '' } : { sucesso: true, registro: 'SAIDA' }
            } else {
              // entrar na sala
              return { sucesso: true, registro: '' }
            }
          }
        } else {
          // registrar entrada
          if (await this.setPresence(agrupamento.data_inicio)) {
            // registrar entrada
            return { sucesso: true, registro: 'ENTRADA' }
          } else {
            this.$toasted.show('Você está atrasado para esta aula!', {
              position: 'top-right',
            })
            return { sucesso: false, registro: null }
          }
        }
      }
    },
    registerFrequency () {
      this.loadBtnPresence = true
      this.loading = true

        if (this.photo === '') {
            this.$toasted.show('Foto necessária para presença!', {
                position: 'top-right',
            })
            this.loadBtnPresence = false
            return
        }

        let role = ''

        if (this.id_role == 4) {
          role = 'ALUNO'
        } else if (this.id_role == 3) {
          role = 'INSTRUTOR'
        }
        let dataPhoto = {
                foto: this.photo,
                cpf: localStorage.cpf
            }
            this.$http.post(urlApi + '/presencas/reconhecimento', dataPhoto).then(function (response) {
                let size = response.data.dados[1]
                let conf = response.data.dados[2]
                if ((conf ** 2 / size) > 70) {
                console.log('Foto inválida!')
                }
            }).catch(function (err) {
                console.log(err)
        })

        let data = {
          entidade: role,
          id: localStorage.id,
          turma: this.agrupamento.id_turma_teorica,
          dispositivo: 'navegador'

        }
        this.$http.post(urlApi + '/ead/presenca', data).then(function (response) {
          this.$toasted.show('Sucesso', {
            position: 'top-right',
          })
          this.join(this.agrupamento)
        }).catch(function (error) {
          this.$toasted.show(error.body.mensagem, {
            position: 'top-right',
          })
        })

    },
    self () {
      // Captura elemento de vídeo
      const video = document.querySelector('#webCamera')
      // Criando um canvas que vai guardar a imagem temporariamente
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      // Desenhando e convertendo as dimensões
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
      // Criando o JPG
      var dataURI = canvas.toDataURL('image/jpeg') // O resultado é um BASE64 de uma imagem.
      document.querySelector('#self').setAttribute('src', dataURI)
      this.photo = dataURI
      this.$toasted.show('Foto capturada, agora registre sua presença!', {
        position: 'top-right',
      })
    },
    async loadData () {
      const dateInicio = new Date().toISOString().split('T')[0]

      await this.$http.get(`${urlApi}/turmas/teoricas/virtuais`, { date_inicio: dateInicio })
        .then(async (response) => this.callbackData(response))
        .catch(err => {
          console.log(err)
        })
    },
    async callbackData (response) {
      this.loadingData = true

      const turmas = response.body.turmas
      const reposicoes = response.body.reposicao
      const today = (await hourCurrentController.consultarHoraAtual()).split(' ')
      const now = new Date(today[0].replace(/-/g, '/'))

      turmas.forEach(turma => {
        const turmaInicio = new Date(turma.data_inicio.replace(/-/g, '/'))

        if (turmaInicio > now) {
          turma.data_inicio = turmaInicio
          turma.data_fim = new Date(turma.data_fim.replace(/-/g, '/'))
          this.turmas.push(turma)
        }
      })

      this.loadingData = false
    },
    async setCurrentTurma () {
      if (!this.turmas.length) {
        return
      }

      const today = (await hourCurrentController.consultarHoraAtual()).split(' ')
      const now = new Date(today)

      const turmasToday = this.turmas.filter(turma => {
        const dataInicio = new Date(turma.data_inicio)
        return dataInicio.getDate() === now.getDate() && dataInicio.getMonth() === now.getMonth()
      })

      if (turmasToday.length === 1) {
        this.currentTurma = turmasToday[0]

        return
      }

      const currentTurmaIndex = this.turmas.findIndex((turma, index) => {
        const homeLimit = new Date(turma.data_inicio.getTime() - 30 * 60000)
        const endLimit = new Date(turma.data_fim.getTime() + 30 * 60000)

        return now > homeLimit && now < endLimit
      })

      if (currentTurmaIndex !== -1) {
        this.currentTurma = this.turmas[currentTurmaIndex]

        this.turmas = this.turmas.slice(currentTurmaIndex)
      } else {
        const turmas = turmasToday.filter(turma => turma.data_inicio > now)

        if (turmas.length) {
          this.currentTurma = turmasToday[turmasToday.length - 1]
        } else {
            this.currentTurma = this.turmas[0]
        }

        const currentTurmaIndex = this.turmas.findIndex(turma => turma.agrupamento === this.currentTurma.agrupamento)

        this.turmas = this.turmas.slice(currentTurmaIndex)
      }
    },
    getCurrentDateUSA () {
      let date = new Date()
      let day = String(date.getDate()).padStart(2, '0')
      let month = String(date.getMonth() + 1).padStart(2, '0')
      let year = date.getFullYear()
      return year + '-' + month + '-' + day
    },
    async validateBeginTime (begin, finish) {
      const dateIBGE = await hourCurrentController.consultarHoraAtual()
      const dateNow = new Date(dateIBGE.replace(/-/g, '/'))
      // tolerancia de 30 min de entrada antes da aula
      const beginTime = new Date(begin.getTime())
      beginTime.setMinutes(beginTime.getMinutes() - 30)
      // tolerancia de 15 min após a aula
      const finishTime = new Date(finish.getTime())
      finishTime.setMinutes(finishTime.getMinutes() + 30)
      if (dateNow.getTime() > beginTime.getTime() && dateNow.getTime() <= finishTime.getTime()) {
        return true
      } else {
        return false
      }
    },
    async getPresence (agrupamento) {
      try {
        await this.$http.get(urlApi + '/turmas/presenca/aluno/' + agrupamento.id_turma_teorica)
        return true
      } catch (error) {
        return false
      }
    },
    async setExit (finish) {
      const dateIBGE = await hourCurrentController.consultarHoraAtual()
      const dateNow = new Date(dateIBGE.replace(/-/g, '/'))
      // toletancia de 30 min após a aula
      const finishTolerance = new Date(finish)
      finishTolerance.setMinutes(finishTolerance.getMinutes() + 30)
      if (dateNow.getTime() > finish.getTime() && dateNow.getTime() < finishTolerance.getTime()) {
        return true
      } else {
        return false
      }
    },
    async setIntervalo (agrupamento) {
      var dateIBGE = await hourCurrentController.consultarHoraAtual()
      var dateNow = new Date(dateIBGE.replace(/-/g, '/'))
      if (agrupamento.intervalo_inicio === null) {
        return false
      }
      let beginInterval = new Date(agrupamento.intervalo_inicio.replace(/-/g, '/'))
      let finishInterval = new Date(agrupamento.intervalo_fim.replace(/-/g, '/'))
      if (dateNow.getTime() > beginInterval.getTime() && dateNow.getTime() < finishInterval.getTime()) {
        return true
      } else {
        return false
      }
    },
    async setPresence (begin) {
      const dateIBGE = await hourCurrentController.consultarHoraAtual()
      const dateNow = new Date(dateIBGE.replace(/-/g, '/'))
      const beginTime = new Date(begin)
      beginTime.setMinutes(beginTime.getMinutes() + 15)
      if (dateNow.getTime() <= beginTime.getTime()) {
        return true
      } else {
        return false
      }
    },
    getAulaTable () {
      this.aula = this.$route.params.status
    },
    async consultLastPresence (idTurma) {
      try {
        let ultimaPresenca = ''
        let retorno = await this.$http.get(urlApi + '/ead/instrutor/presenca/' + idTurma)
        switch (retorno.body.ponto) {
          case 0:
            ultimaPresenca = 'ENTRADA'
            break
          case 1:
            ultimaPresenca = 'SAIDA'
            break
          case 2:
            ultimaPresenca = 'INTERVALO'
            break
          case null:
            ultimaPresenca = 'SEM PRESENÇA'
            break

          default:
            ultimaPresenca = 'PRESENCA NÃO IDENTIFICADA'
            break
        }
        return ultimaPresenca
      } catch (error) {
        return 'FALHA AO CARREGAR A PRESENÇA'
      }
    },
    async verifyClassAvailability () {
      if (!this.turmas.length) {
        this.loadingButtons = false

        return
      }
      const turma = this.currentTurma

      const trintaMinutosAposFim = new Date(turma.data_fim.getTime() + 30 * 60000)
      const quinzeMinutosAposInicio = new Date(turma.data_inicio.getTime() + 15 * 60000)
      const classFinished = this.agora > trintaMinutosAposFim

      const presencaBatida = await this.getPresence(turma)

      if ((this.agora > quinzeMinutosAposInicio && this.agora < trintaMinutosAposFim && !presencaBatida) || classFinished) {
        this.classIsUnavailable = true
      } else {
        this.classAvailability = presencaBatida || this.aulaDisponivel
      }

      this.loadingButtons = false
    },
    async requestCameraPermission () {
      this.loading = true
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        try {
          this.mediaStream = await navigator.mediaDevices.getUserMedia({ video: true })
          this.cameraPermissionGranted = true
          this.cameraPermissionModal = false
          this.showTakePhotoModal = true
          this.loading = false

          // Adiando a configuração do srcObject até que o elemento video esteja disponível
          this.$nextTick(() => {
            if (this.$refs.camera) {
              this.$refs.camera.srcObject = this.mediaStream
            } else {
            }
          })
        } catch (error) {
          console.log(error)
          this.showTakePhotoModal = false
          this.cameraPermissionModal = false
          this.showErrorModal = true
          this.errorMessage = 'Erro ao acessar a câmera. Por favor, verifique suas configurações e tente novamente.'
          this.loading = false
        }
      } else {
        this.showErrorModal = true
        this.errorMessage = 'Seu navegador não suporta a API de mídia. Por favor, tente em um navegador diferente.'
        this.cameraPermissionModal = false
        this.showTakePhotoModal = false
        this.loading = false
      }
    },
    tentarNovamente () {
      this.showCameraModal = true
      this.cameraPermissionGranted = false
      this.showTakePhotoModal = false
      this.capturedImage = null
      this.showErrorModal = false
    },
    takePhoto () {
      if (this.mediaStream) {
        const canvas = document.createElement('canvas')
        const video = this.$refs.camera
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        const context = canvas.getContext('2d')
        context.drawImage(video, 0, 0, canvas.width, canvas.height)

        this.mediaStream.getTracks().forEach((track) => track.stop())

        // Converta a imagem para um formato base64
        this.capturedImage = canvas.toDataURL('image/jpeg')
        this.photo = canvas.toDataURL('image/jpeg')

        // Exibir o modal de visualização
        this.showPreviewModal = true
        this.showTakePhotoModal = false
      }
    },
    async getAlunos () {
      this.verTurmaId = this.currentTurma.id_turma_teorica
      this.verTurmasModal = true
    }
  },
  computed: {
    aulaDisponivel () {
      if (!this.turmas.length) {
        return false
      }

      const agora = this.agora
      const dataInicioTurma = this.currentTurma.data_inicio
      const trintaMinutosAntesInicio = new Date(dataInicioTurma.getTime() - 30 * 60000)
      const quinzeMinutosAposInicio = new Date(dataInicioTurma.getTime() + 15 * 60000)

      return (agora >= trintaMinutosAntesInicio && agora <= quinzeMinutosAposInicio)
    },
    aulaHorario () {
      const turma = this.currentTurma

      const initialDateHour = turma.data_inicio.getHours()
      const initialDateMinutes = turma.data_inicio.getMinutes() < 10 ? '0' + turma.data_inicio.getMinutes() : turma.data_inicio.getMinutes()

      return `${initialDateHour}:${initialDateMinutes}`
    },
  },
  async mounted () {
    await this.loadData()
    await this.setCurrentTurma()

    this.getAulaTable()
    this.tipoProcesso = localStorage.tipo_processo
    this.id_role = localStorage.id_role
    await this.verifyClassAvailability()
  },
  watch: {
    $route (to, from) {
      this.getAulaTable()
    }
  },
  beforeDestroy () {
    Echo.leave(`App.Models.Usuarios.${JSON.parse(localStorage.getItem('usuario')).id_usuario}`)
  }

}
</script>

<style lang="scss" scoped>

.actions-buttons {
  display: flex;
  gap: 1rem;

  button:first-child {
    flex: 1;
  }
}

.turma-button {
  max-width: 8.3125rem;

  display: flex;
  padding: 1.5rem 0.75rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  background: transparent;
  border-radius: 4px;
  border: 3px solid #0F0E0E;

  color: #0F0E0E;
  font-size: 1rem;
  font-weight: 700;
}

.ead-aluno-loading {
  height: 43.9375rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ead-aluno-container {
  width: 100%;
  height: 79vh;
  display: flex;
  gap: 2.5rem;
}

.ead-aluno-aulas,
.ead-aluno-aula-atual {
  max-height: 45.5rem;
  background: #ffffff;
}

.ead-aluno-aulas {
  width: 32.1875rem;
  padding: 3rem 2rem;
}

.ead-aluno-aulas-full {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  overflow-y: auto;
}

.ead-aluno-aula-atual {
  flex: 1;
  padding: 5.53125rem 5.5625rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.ead-aluno-aula-container {
  width: 100%;
}

.ead-aluno-aula-banner {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.aulas-agendadas-not-found {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.aulas-agendadas-not-found>p {
  color: #0F0E0E;
  font-size: 1rem;
  font-weight: 600;
}

.aulas-agendadas-empty-warning {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.aulas-agendadas-empty-warning>span {
  color: #0F0E0E;
  font-size: 1.5rem;
  font-weight: 700;
}

.aulas-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.aulas-header>strong {
  color: #1E2F5B;
  font-size: 1.5rem;
  font-weight: 700;
}

.botao-acessar-aula {
  width: 100%;
  border: 0;
  border-radius: 4px;
  padding: 1.5rem 0.75rem;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  color: #0F0E0E;
  font-size: 1rem;
  font-weight: 700;
}

.disabled-button {
  background: #CACACA;
  cursor: not-allowed;
}

.able-button {
  background: #FABF10;
}

.btnpresenca {
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  border-radius: 3px;
  width: 135px !important;
  margin: 0 auto !important;
  height: 35px;
  padding-left: 15px;
}

.table td,
.table th,
.table thead th,
.table thead td {
  text-align: center !important;
}

.vuestic-modal .my-modal-body {
  background-color: #ffedc1;
  font-size: 20px;
  padding: 40px;
  border-radius: 0px !important;
  margin: 0px !important;
  width: auto !important;
  height: auto !important;
}

.btnpresenca:hover {
  color: #ffffff;
  border-radius: 3px;
}

.btnpresenca:focus {
  outline: none;
  box-shadow: none;
  color: #ffffff;
  border-radius: 3px;
}

.fa.fa-sign-in {
  width: 150px;
}

.btnmodal {
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  border-radius: 3px;
  width: auto !important;
  padding: 0px 20px !important;
  height: 35px;
  margin: 5px;
}

.btnmodal:hover {
  color: #ffffff;
  border-radius: 3px;
}

.btnmodal:focus {
  outline: none;
  box-shadow: none;
  color: #ffffff;
  border-radius: 3px;
}
</style>
